<template>

    <div id="lt_press">
        <h3>עיתונות</h3>
        <div class="links_wrapper">
          <h4>הורדת קובץ לעיתונות: </h4>
          <a class="download" :href="item.press_pdf_path">PDF<i class="fas fa-arrow-down"></i></a>
          <a v-if="item" class="download" :href="wordDownloadLink">WORD<i class="fas fa-arrow-down"></i></a>
        </div>

        <!-- <embed v-if="item.press_pdf_path" id="press_embed" :src="item.press_pdf_path" width="100%" height="100%" style="min-height:300px; min-height:65vh;"> -->
        <iframe v-if="item.press_pdf_path" frameBorder="0" scrolling="no" id="press_embed" :src="item.press_pdf_reader_url" width="100%" height="100%" style="min-height:300px; min-height:65vh;"></iframe> 

    </div>
</template>

<script>



export default {
  props: ["item"],
  data(){
    return {
        
    }
  },
  computed:{
    wordDownloadLink(){
      return window.site_url + 'lnk_download/press/' + this.item.id + '?type=press_doc&tk=' + this.$route.query.tk;
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.download { float: left; color: #fff !important;}
.links_wrapper{display: flex;align-items: center;margin-bottom: 10px;
  h4{margin-left: 10px;}
  a.download{margin-left: 15px;display: flex;align-items: center;gap: 4px;}
}
#press_embed{background-color: #fff;}
h3 { margin-bottom: 15px;}
</style>